'use strict';
import angular from 'angular';
import dfpHtmlUrl from './views/inventory.filter.html';

var app = angular.module('app.inventoryFilterComponent', []);

app.component('inventoryFilterWidget', {
  bindings: {
    clientId: '=',
    clusterId: '=',
    productId: '=',
    lookup: '=',
    showActions: '=',
    selectedFieldData: '='
  },
  templateUrl: dfpHtmlUrl,

  // The controller that handles our component logic
  controller: function ($ioAlert, ProductService, OrdersService, FormService) {
    var self = this;
    self.inventorydata = [];
    self.filterObj = {};
    // Method for getting Inventory Filter API Data
    self.getInventoryFilterAPIData = function(getProductList,merchantId){
      ProductService.getExistingProductLists(getProductList,merchantId).then(function(response) {
        self.inventorydata = response;
        self.inventoryKeys = _.keys(self.inventorydata[0]);
      }, function(error) {
          $rs.loadingInProgress = false;
      });
    }

    // Method for getting Merchant ID
    self.getMerchantId = function() {
      ProductService.getProductDfpKeys(self.clientId, self.clusterId, self.productId, self.lookup).then(function(data) {
          data.productFields.forEach(function(product){
              if(product.field_name == 'merchant_center_account' ){
                  product.lookup_content.forEach(function(lookups){
                  self.merchantid = lookups.lookup_value;
                  });
              }
          });
          self.getInventoryFilterAPIData("GET_PRODUCT_LIST",self.merchantid);
      }, function(error) {
              console.log("error getting Inventory Filters API Data");
      });
  }

    self.value = "";
    self.inventoryKeys = [];
    self.filterdata = [];
    self.selected = "";
    self.disabled = {};

    self.selectKey = function (item) {
        if(self.selectedFieldData.length==1){
          self.filterdata = _.map(self.inventorydata, item.attributeType);
        }
        else{
          var dataByParent =  _.filter(self.inventorydata, self.filterObj);
          self.filterdata = _.map(dataByParent, item.attributeType);
        }
      item.attributeValue = '';
      var filtercount = self.filterdata.reduce(function (obj, b) {
        obj[b] = ++obj[b] || 1;
        return obj;
      }, {});
      self.filterdata = _.uniq(self.filterdata)
      _.map(self.filterdata, function (item, index) {
        var t = filtercount[item];
        self.filterdata[index] = item + " " + "(" + t + " " + "Products" + ")";
      });
    }
    self.onSelect = function (model, item) {
      item.attributeValue = model.replace(/\s*\([^)]+\)(?![^(]*\()/g, "");
    }
    self.removeColumn = function (item, index) {
      if (self.selectedFieldData.length - 1 == index) {
        self.selectedFieldData[index - 1].isDisabled = false;
        self.selectedFieldData[index - 1].isHidden = false;
        self.disabled[self.selectedFieldData[index - 1].attributeType] = false;
      }
      else {
        self.disabled[item.attributeType] = false;
      }
      self.selectedFieldData.splice(index, 1);
        delete self.filterObj[item.attributeType];
    }
    self.addNewColumn = function (item) {
      item.isDisabled = true;
      item.isHidden = true;
      self.filterdata = [];
      self.filterObj[item.attributeType] = item.attributeValue;
      var newItemNo = self.selectedFieldData.length + 1;
      self.selectedFieldData.push({ 'colId': 'col' + newItemNo, attributeType: '', attributeValue: '', isDisabled: false, isHidden: false });
    }
    self.refreshFilterData = function (item){
      if(item.attributeValue == ""){
        self.selectKey(item);
      }
    }
    self.initComponent = function () {
      if(self.showActions){
        self.getMerchantId();
        self.editMode = true;
        if(typeof this.selectedFieldData == "string" && this.selectedFieldData !== "" && this.selectedFieldData !=="[]"){
          self.selectedFieldData = JSON.parse(self.selectedFieldData);
          self.editClassOptions = "align-options"
        }
        else{
          self.editClassOptions = "align-options"
          self.selectedFieldData = [{ colId: 'col1', attributeType: '', attributeValue: '', isDisabled: false, isHidden: false }];
        }
      }
      else{
        self.selectedFieldData = JSON.parse(self.selectedFieldData);
        self.editMode = false;
      }
    };
    self.initComponent();
  }
});
app.directive('typeaheadFocus', function () {
  return {
    require: 'ngModel',
    link: function (scope, element, attr, ngModel) {

      //trigger the popup on 'click' because 'focus'
      //is also triggered after the item selection
      element.bind('click', function () {

        var viewValue = ngModel.$viewValue;

        //restore to null value so that the typeahead can detect a change
        if (ngModel.$viewValue == ' ') {
          ngModel.$setViewValue(null);
        }

        //force trigger the popup
        ngModel.$setViewValue(' ');

        //set the actual value in case there was already a value in the input
        ngModel.$setViewValue(viewValue || ' ');
      });

      //compare function that treats the empty space as a match
      scope.emptyOrMatch = function (actual, expected) {
        if (expected == ' ') {
          return true;
        }
        return actual.indexOf(expected) > -1;
      };
    }
  };
});